import { useQuery } from "@tanstack/react-query";
import { getArtist } from "../api/artistsApi";
import { queryKeys } from "../lib/queryKeys";

export function useArtistDetail(id: string) {
  return useQuery({
    queryKey: queryKeys.artists.detail(id),
    queryFn: () => getArtist(id),
    enabled: Boolean(id),
  });
}
